module.exports = __webpack_public_path__ + "img/background.d6ce35a1.png";